import { RepositoryFactory } from "../../../../src/api/repositories/RepositoryFactory";
import { selectPageInParentWindow } from "./pageUtils";
import {successfulResponse} from "../../../../src/api/Response";
const SiteTemplateRepository = RepositoryFactory.get('siteTemplates');
const PagesRepository = RepositoryFactory.get('pages');

const SET_GLOBAL_STYLES = (state, globalStyles) => {
  state.globalStyles = {
    ...state.globalStyles,
    ...globalStyles,
  };
};

const SiteTemplatesRepository = RepositoryFactory.get("siteTemplates");

const state = {
  activeSiteTemplate: null, //holds the id of the active site template null if legacy
  currentSiteTemplate: null, //holds the id of the current viewed site template (not necessarily activated)
  siteTemplates: [], //holds all SiteTemplates
  lastSavedSiteTemplatesData: [], //holds all SiteTemplates
  allSiteTemplatesPages: [],
  siteTemplateSourceSettings: null,
  siteTemplateHeadIncludes: {
    "logged-in": "",
    "logged-out": "",
  },
  siteTemplateBodyIncludes: {
    "logged-in": "",
    "logged-out": "",
  },

  siteTemplateIncludesAfterPurchase: "",
  siteTemplateIncludesAfterRegistration: "",

  siteTemplateCssBuiltIn: "",
  siteTemplateCssDynamic: "",

  navigation: {
    logoutUrl: null,
    loginRedirect: null,
    nonpayingUsersAllowedUrl: null,
  },
  responsiveFontScale: null,
};

const getters = {
  currentSiteTemplatePages: (state) => {
    return state.allSiteTemplatesPages.filter(
      (page) => page.site_template === state.currentSiteTemplate
    )
  },
  siteTemplate: (state, getters, rootState) => {
    if (!rootState.pages.pageData || !rootState.pages.pageData.site_template) {
      return "";
    }
    return rootState.pages.pageData.site_template;
  },
  currentSiteTemplateData: (state) =>
    state.siteTemplates.find(
      (template) => template.id === state.currentSiteTemplate
    ),
  currentSiteTemplateStyle(state, getters) {
    return getters.currentSiteTemplateData
      ? getters.currentSiteTemplateData.styling
      : {};
  },
};

const mutations = {
  updatePage(state, page) {
    let idx = state.allSiteTemplatesPages.findIndex(
      (current) => current.id === page.id
    );
    if (idx > -1) {
      Object.assign(state.allSiteTemplatesPages[idx], page);
    }
  },
  addUpdateCurrentSiteTemplatePage(state, page) {
    let index = state.allSiteTemplatesPages.findIndex(
      (statePage) => statePage.id === page.id
    );
    if (index > -1) {
      state.allSiteTemplatesPages[idx] = page;
    } else {
      state.allSiteTemplatesPages.push(page);
    }
  },
  setSiteTemplateSourceSettings(state, payload) {
    state.siteTemplateSourceSettings = payload;
  },
  setCurrentSiteTemplatePages(state, pages) {
    state.allSiteTemplatesPages = [
      ...state.allSiteTemplatesPages.filter(
        (page) => page.site_template !== state.currentSiteTemplate
      ),
      ...pages
    ]
  },
  setSiteTemplatePages(state, { pages, siteTemplateId }) {
    state.allSiteTemplatesPages = [
      ...state.allSiteTemplatesPages.filter(
        (page) => page.site_template !== siteTemplateId
      ),
      ...pages,
    ];
  },
  setActiveSiteTemplate(state, id) {
    state.activeSiteTemplate = id;
  },
  setSiteTemplates(state, payload) {
    state.siteTemplates = payload;
    state.lastSavedSiteTemplatesData = copyJson(payload);
  },
  setCurrentSiteTemplate(state, siteTemplateId) {
    state.currentSiteTemplate = siteTemplateId;
  },

  setCurrentSiteTemplateIncludes(state, currentSiteTemplateData) {
    state.siteTemplateCssBuiltIn = currentSiteTemplateData.css_built_in || "";
    state.siteTemplateCssDynamic = currentSiteTemplateData.css_dynamic || "";
    state.siteTemplateIncludesAfterPurchase =
      currentSiteTemplateData.includes_after_purchase || "";
    state.siteTemplateIncludesAfterRegistration =
      currentSiteTemplateData.includes_after_registration || "";

    if (currentSiteTemplateData.includes_head) {
      state.siteTemplateHeadIncludes = {
        "logged-in": currentSiteTemplateData.includes_head["logged-in"] || "",
        "logged-out": currentSiteTemplateData.includes_head["logged-out"] || "",
      };
    }

    if (currentSiteTemplateData.includes_body) {
      state.siteTemplateBodyIncludes = {
        "logged-in": currentSiteTemplateData.includes_body["logged-in"] || "",
        "logged-out": currentSiteTemplateData.includes_body["logged-out"] || "",
      };
    }
  },

  setCurrentSiteTemplateNavigation(state, currentSiteTemplateData) {
    state.navigation.logoutUrl =
      currentSiteTemplateData.setting_logout_url || null;
    state.navigation.loginRedirect =
      currentSiteTemplateData.setting_login_redirect || null;
    state.navigation.nonpayingUsersAllowedUrl =
      currentSiteTemplateData.setting_nonpaying_users_allowed_url || null;
  },

  setSiteTemplateIncludes(state, data) {
    let currentTemplateIndex = state.siteTemplates.findIndex(
      (template) => template.id === state.currentSiteTemplate
    );
    let currentTemplateData = state.siteTemplates[currentTemplateIndex];

    // create some keys in currentTemplateData if they don't exist or are null
    if (!currentTemplateData.includes_head) {
      currentTemplateData.includes_head = {
        "logged-in": "",
        "logged-out": "",
      }
    }
    if (!currentTemplateData.includes_body) {
      currentTemplateData.includes_body = {
        "logged-in": "",
        "logged-out": "",
      }
    }

    if (data.key == "siteTemplateHeadIncludesLoggedIn") {
      state.siteTemplateHeadIncludes["logged-in"] = data.content;
      currentTemplateData.includes_head["logged-in"] = data.content;
    } else if (data.key == "siteTemplateHeadIncludesLoggedOut") {
      state.siteTemplateHeadIncludes["logged-out"] = data.content;
      currentTemplateData.includes_head["logged-out"] = data.content;
    } else if (data.key == "siteTemplateBodyIncludesLoggedIn") {
      state.siteTemplateBodyIncludes["logged-in"] = data.content;
      currentTemplateData.includes_body["logged-in"] = data.content;
    } else if (data.key == "siteTemplateBodyIncludesLoggedOut") {
      state.siteTemplateBodyIncludes["logged-out"] = data.content;
      currentTemplateData.includes_body["logged-out"] = data.content;
    } else if (data.key == "siteTemplateCssBuiltIn") {
      state.siteTemplateCssBuiltIn = data.content;
      currentTemplateData.css_built_in = data.content;
    } else if (data.key == "siteTemplateCssDynamic") {
      state.siteTemplateCssDynamic = data.content;
      currentTemplateData.css_dynamic = data.content;
    } else if (data.key == "siteTemplateIncludesAfterPurchase") {
      state.siteTemplateIncludesAfterPurchase = data.content;
      currentTemplateData.includes_after_purchase = data.content;
    } else if (data.key == "siteTemplateIncludesAfterRegistration") {
      state.siteTemplateIncludesAfterRegistration = data.content;
      currentTemplateData.includes_after_registration = data.content;
    }
    state.siteTemplates[currentTemplateIndex] = currentTemplateData;
  },
  setResponsiveFontScale(state, data) {
    //console.log('**** Site template module Mutation setResponsiveFontScale payload: ', data);
    state.responsiveFontScale = data;
  },
};

const actions = {
  retrieveSiteTemplatePages({ commit }, payload) {
    if (payload) {
      PagesRepository.getPages(payload).then((pages) => {
        commit("setSiteTemplatePages", { pages, siteTemplateId: payload["site_template"] });
      });
    }
  },
  setCurrentSiteTemplate({ commit, dispatch, getters }, payload) {
    commit("setCurrentSiteTemplate", payload);
    dispatch("retrieveSiteTemplatePages", { "site_template": payload });

    if (getters.currentSiteTemplateData) {
      commit("setCurrentSiteTemplateIncludes", getters.currentSiteTemplateData);
      commit(
        "setCurrentSiteTemplateNavigation",
        getters.currentSiteTemplateData
      );
      dispatch(
        "topbar/setSchoolTopbarData",
        getters.currentSiteTemplateData.topbar,
        { root: true }
      );
      dispatch(
        "footer/setSchoolFooterData",
        getters.currentSiteTemplateData.footer,
        { root: true }
      );
      commit(
        "setResponsiveFontScale",
        getters.currentSiteTemplateData.responsive_font_scale
      );
    }
  },
  loadActiveSiteTemplate({ commit }) {
    if (window.activeSiteTemplate) {
      return new Promise((resolve, reject) => {
        commit('setActiveSiteTemplate', window.activeSiteTemplate);
        resolve(window.activeSiteTemplate)
      });
    }


    return SiteTemplateRepository.getActiveTemplate().then(({ data }) => {
      if (data.active) {
        commit("setActiveSiteTemplate", data.active);
      }
    });
  },
  loadSiteTemplates({ commit }) {
    return SiteTemplateRepository.getTemplates().then(({ data }) => {
      if (data.templates) {
        commit("setSiteTemplates", data.templates);
      }
      //Todo: add Error handling
    });
  },
  changeSiteTemplate({ dispatch }, payload) {
    dispatch("setCurrentSiteTemplate", payload);
    dispatch("retrieveSiteTemplatePages", { "site_template": payload });
    selectPageInParentWindow({ slug: "home", type: "home" });
    dispatch(
      "pages/setPageContext",
      { slug: "home", type: "home" },
      { root: true }
    );
  },
  resetSchoolTopbarFooter({ dispatch, getters }) {
    if (getters.currentSiteTemplateData) {
      dispatch(
        "topbar/setSchoolTopbarData",
        getters.currentSiteTemplateData.topbar,
        { root: true }
      );
      dispatch(
        "footer/setSchoolFooterData",
        getters.currentSiteTemplateData.footer,
        { root: true }
      );
    }
  },
  saveNavigation({ dispatch }, navigation) {
    dispatch("saveSiteTemplate", {
      setting_logout_url: navigation.logoutUrl,
      setting_login_redirect: navigation.loginRedirect,
      setting_nonpaying_users_allowed_url: navigation.nonpayingUsersAllowedUrl,
    }).then((axiosResult) => {
      if (successfulResponse(axiosResult)) {
        showMessage("success", "Success", "Properties saved");
      } else {
        // TODO Error ??
        showMessage(
            "error",
            "An error occurred.",
            "Navigation was not saved"
        );
        console.error("Failed to save navigation settings", axiosResult);
      }
    });
  },
  saveSiteTemplate({ commit, state, getters }, payload) {
    if (!payload.id) {
      payload.id = state.currentSiteTemplate;
    }

    return SiteTemplateRepository.saveTemplate(payload).then((axiosResult) => {
      let { data } = axiosResult;

      if (data.templates) {
        commit("setSiteTemplates", data.templates);
        if (getters.currentSiteTemplateData) {
          // commit('setCurrentSiteTemplateIncludes',  getters.currentSiteTemplateData);
          // commit('setCurrentSiteTemplateNavigation',  getters.currentSiteTemplateData);
          // dispatch("topbar/setSchoolTopbarData", getters.currentSiteTemplateData.topbar,{root:true});
          // dispatch("footer/setSchoolFooterData", getters.currentSiteTemplateData.footer,{root:true});
        }
      }

      return axiosResult;
    });
  },
  getCurrentSiteTemplateSourceSettings({ dispatch, getters }) {
    return dispatch(
      "getSiteTemplateSourceSettings",
      getters.currentSiteTemplateData.source
    );
  },
  getSiteTemplateSourceSettings({ state, commit }, source) {
    if (!state.siteTemplateSourceSettings) {
      return SiteTemplatesRepository.getSiteTemplateSourceSettings(source).then(
        (response) => {
          commit("setSiteTemplateSourceSettings", response.data);
          return state.siteTemplateSourceSettings;
        }
      );
    } else {
      return new Promise((resolve, reject) => {
        resolve(state.siteTemplateSourceSettings);
      });
    }
  },
  setResponsiveFontScale({ commit }, payload) {
    commit("setResponsiveFontScale", payload);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
